<template>
  <el-dialog title="更改密码" :visible.sync="showDialog" width="30%" :before-close="hiddenView">
    <el-form :model="formData" :rules="rules" ref="passForm" label-width="80px">
      <el-form-item label="原密码" prop="old_pass">
        <el-input v-model.trim="formData.old_pass" type="password" autocomplete="off" show-password placeholder="请输入原密码"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="new_pass">
        <el-input v-model.trim="formData.new_pass" type="password" autocomplete="off" show-password placeholder="请输入新密码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">立即更改</el-button>
        <el-button @click="hiddenView">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { updateUserPassword } from "@/api/user"
export default {
  name: "EditPassword",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      userinfo: {},
      showDialog: false,
      rules: {
        old_pass: [
          { required: true, message: "请输入原密码", trigger: "blur" },
          { min: 6, max: 12, message: "长度在 6 到 12 个字符", trigger: "blur" }
        ],
        new_pass: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, max: 12, message: "长度在 6 到 12 个字符", trigger: "blur" }
        ]
      },
      formData: {
        old_pass: "",
        new_pass: ""
      }
    }
  },
  watch: {
    show: {
      handler(newVal) {
        this.showDialog = newVal
        this.resetformData()
        //this.$refs.passForm.clearValidate()
      },
      immediate: true
    }
  },
  methods: {
    resetformData() {
      this.formData = {
        old_pass: "",
        new_pass: ""
      }
    },
    onSubmit() {
      this.$refs["passForm"].validate(valid => {
        if (valid) {
          this.userinfo = JSON.parse(localStorage.getItem("user_info"))
          const uid = this.userinfo["uid"]
          updateUserPassword(uid, this.formData).then(res => {
            this.$notify({
              message: res.message,
              type: res.type
            })
            if (res.type === "success") {
              this.$emit("close")
            }
          })
        } else {
          return false
        }
      })
    },
    hiddenView() {
      this.$nextTick(() => {
        this.$refs.passForm.clearValidate()
      })
      this.$emit("close")
    }
  }
}
</script>

<style></style>
